import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const MobileSelectListItem = ({
	label,
	controlTitleField,
	maxTitleLength,
	options,
	valueField,
	selectedValue,
	resetOption,
	name,
	switchFilter,
	defaultFiltersValues
}) => {
	const selectedOption = (() => {
		let res = _(options).findWhere({
			[valueField]: String(selectedValue)
		});

		if (name === 'tags') {
			res = _(options).findWhere({
				[valueField]: selectedValue
			});
		}

		if (!res) {
			res = resetOption;
		}

		return res;
	})();

	let title = selectedOption[controlTitleField];

	if (maxTitleLength && title.length > maxTitleLength * 1.2) {
		title = `${title.slice(0, maxTitleLength)}...`;
	}

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus
		<div
			role="button"
			onClick={() => switchFilter({ label, value: selectedValue, name }, true)}
			className={styles.MobileSelectListItem}
		>
			<div className={styles.MobileSelectListItem__Filler} />
			<div className={styles.MobileSelectListItem__Title}>{title}</div>
			<Icon
				icon="chevronRight"
				className={
					selectedValue && selectedValue !== defaultFiltersValues[name]
						? styles.MobileSelectListItem__CloseIcon
						: styles.MobileSelectListItem__ButtonIcon
				}
			/>
		</div>
	);
};

MobileSelectListItem.propTypes = {
	resetOption: PropTypes.shape({
		title: PropTypes.string.isRequired,
		name: PropTypes.string
	}),
	defaultFiltersValues: PropTypes.object,
	controlTitleField: PropTypes.string,
	label: PropTypes.string,
	name: PropTypes.string,
	maxTitleLength: PropTypes.number,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			name: PropTypes.string
		})
	),
	valueField: PropTypes.string,
	selectedValue: PropTypes.node,
	switchFilter: PropTypes.func
};

MobileSelectListItem.defaultProps = {
	label: '',
	name: '',
	options: [],
	valueField: 'name',
	selectedValue: '',
	resetOption: { title: 'Показать все', name: '' },
	controlTitleField: 'title'
};

export default MobileSelectListItem;
